import {
  CustomerInfoSearchQuery,
  CustomerInfoSearchQueryVariables,
  InfoSearchBySComerNumberOrIndexFragment,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";
import _ from "lodash";
import { useMemo } from "react";

const customerSearchQuery = gql`
  fragment infoSearchBySComerNumberOrIndex on Customer {
    id
    custIndex
    custStatus {
      id
      name
      code
    }
    custNo
    name
    parent {
      id
    }
  }
  query CustomerInfoSearch($query: String!) {
    productPrice {
      customers {
        byCustomerNumberOrIndex(query: $query) {
          ...infoSearchBySComerNumberOrIndex
        }
      }
    }
  }
`;
export type CustomerInfoResult = InfoSearchBySComerNumberOrIndexFragment;
export const useLoadCustomers = () => {
  const [fetchCustomers, { loading, data, error, refetch }] = useLazyQuery<
    CustomerInfoSearchQuery,
    CustomerInfoSearchQueryVariables
  >(customerSearchQuery);

  const debouncedPost = useMemo(
    () =>
      _.debounce(
        (input: string) => fetchCustomers({ variables: { query: input } }),
        300
      ),
    [fetchCustomers]
  );

  return {
    fetchCustomers: debouncedPost,
    loading,
    customers: data?.productPrice.customers.byCustomerNumberOrIndex,
    error,
    refetch,
  };
};
